// Path: src\Components\UserInGameName\UserInGameName.jsx
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "../CommonFields/Button";

import {
    getUserInGameName,
    editUserInGameName,
} from "../../api/userInGameName.api";
import { url } from "../../config/url";
import BasePopup from "../Popup/BasePopup";
import TextInput from "../CommonFields/TextInput";
import { toastSuccess, toastError } from "../../Utilities/toast";

import { useProfileDataContext } from "../ProfileContext/ProfileContext";

const UserInGameNamePopUp = ({
    children,
    inGameNamePopup,
    setinGameNamePopup,
}) => {
    const { t } = useTranslation();

    const gameId = localStorage.getItem("activeGameId");
    const gameName = localStorage.getItem("activeGame")?.toLocaleLowerCase();
    const profile = JSON?.parse(localStorage.getItem("profile"));

    const [userInGameName, setUserInGameName] = useState("");
    const [userInGameNameExists, setUserInGameNameExists] = useState(false);
    const [newUserInGameName, setNewUserInGameName] = useState("");
      const [errorMessage, setErrorMessage] = useState(""); 
    const { liteProfile } = useProfileDataContext();

    useEffect(() => {
        if (inGameNamePopup) {
            fetchUserInGameName();
        }
    }, [inGameNamePopup]);

    const fetchUserInGameName = async () => {
        try {
            const res = await getUserInGameName({
                game: gameId,
                user: profile?.user_id,
            });
            if (res?.success && res?.data) {
                if (res?.data?.userINGameName) {
                    setUserInGameName(res?.data?.userINGameName);
                    setUserInGameNameExists(true);
                    setNewUserInGameName("");
                } else {
                    setUserInGameName("");
                    setUserInGameNameExists(false);
                    setNewUserInGameName("");
                }
            } else {
                setUserInGameName("");
                setUserInGameNameExists(false);
                setNewUserInGameName("");
            }
        } catch (error) {
        }
    };

    const updateUserInGameName = async () => {
        try {
            let error = false;

            let payload = {
                game: gameId,
                user: profile?.user_id,
            };

            if (userInGameNameExists) {
                if (
                    newUserInGameName?.trim() == "" ||
                    newUserInGameName?.trim() == null ||
                    newUserInGameName?.trim() == "null" ||
                    newUserInGameName?.trim() == undefined ||
                    newUserInGameName?.trim() == "undefined"
                ) {
                    error = true;
                    setErrorMessage(t('validations.please_enter_user_in_game_name'));
                    // toastError(t('validations.please_enter_user_in_game_name'));
                    return;
                }
                payload.userINGameName = newUserInGameName?.trim();
            } else {
                if (
                    userInGameName?.trim() == "" ||
                    userInGameName?.trim() == null ||
                    userInGameName?.trim() == "null" ||
                    userInGameName?.trim() == undefined ||
                    userInGameName?.trim() == "undefined"
                ) {
                    error = true;
                    setErrorMessage(t('validations.please_enter_user_in_game_name'));
                    // toastError(t('validations.please_enter_user_in_game_name'));
                    return;
                }
                payload.userINGameName = userInGameName?.trim();
            }

            if (!error) {
                const res = await editUserInGameName(payload);
                if (res?.success) {
                    toastSuccess(res?.data?.[0]?.msg);
                    setinGameNamePopup(false);
                } else {
                    toastError(res?.data?.errors?.[0]?.msg);
                }
            }
        } catch (error) {
            toastError(error?.response?.errors?.[0]?.msg);
        }
    };

    return (
        inGameNamePopup && (
            <BasePopup
                isOpen={inGameNamePopup}
                title={t('user_in_game_name.add_game_user_name', { gameName: gameName })}
                onClose={() => setinGameNamePopup(false)}
            >
                <div className="user-in-game-name mb-3">
                    <TextInput
                        labelName={t('user_in_game_name.game_user_name', { gameName: gameName })}
                        placeholder={t('errors.error_enter_user_in_game_name', { gameName: gameName })}
                        value={userInGameName}
                         inputLength ="32"
                         disabled={userInGameNameExists}
                        //  helperText={errorMessage}
                        // readOnly={userInGameNameExists}
                        onChange={(e) => {
                            setUserInGameName(e?.target?.value);
                            setErrorMessage(""); 
                        }}
                    />
                    {/* {errorMessage && <div className="error-message">{errorMessage}</div>} */}
                    {userInGameNameExists && (
                        <TextInput
                            labelName={t('user_in_game_name.new_game_user_name', { gameName: gameName })}
                            placeholder={t('errors.error_enter_new_user_in_game_name', { gameName: gameName })}
                            value={newUserInGameName}
                             inputLength ="32"
                            readOnly={false}
                            // helperText={errorMessage}
                            onChange={(e) => {
                                setNewUserInGameName(e?.target?.value);
                                setErrorMessage(""); 
                            }}
                        />
                    )}
 {errorMessage && <div className="error-message" style={{bottom:"80px",left:"30px"}}>{errorMessage}</div>}
                </div>
                <Button text={t("submit")} onClick={() => updateUserInGameName()} />
            </BasePopup>
        )
    );
};

export default UserInGameNamePopUp;
